<template>
  <v-container>
    <v-row align="center">
      <v-col
        cols=12
        sm=3
      >
        <v-text-field
          :label="$t('registration')"
          v-model="vessel.registration"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('call_sign')"
          v-model="vessel.call_sign"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('mode_s')"
          v-model="vessel.mode_s"
        />
      </v-col>

      <v-col
        cols=12
        sm=3
      >
        <v-text-field
          :label="$t('serial')"
          v-model="vessel.serial"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('brand')"
          v-model="vessel.brand"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('model')"
          v-model="vessel.model"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <year-picker
          :label="$t('year_of_build')"
          :picker.sync="vessel.yearPicker"
        ></year-picker>
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('airline')"
          v-model="vessel.airline"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('weight')"
          v-model="vessel.weight"
          type="number"
        />
      </v-col>

      <v-col
        cols=6
        sm=3
      >
        <v-text-field
          :label="$t('colour')"
          v-model="vessel.colour"
        />
      </v-col>

      <v-col
        cols=12
        sm=3
      >
        <v-text-field
          :label="$t('home_airbase')"
          v-model="vessel.home_airbase"
        />
      </v-col>

      <v-col
        cols=12
        sm=3
      >
        <v-select
          :items="countries"
          :label="$t('flag')"
          :item-text="item => $t(item.text)"
          item-value="value"
          v-model="vessel.flag"
          clearable
        ></v-select>
      </v-col>

      <v-col
        cols=12
        sm=6
      >
        <v-text-field
          hide-details
          :label="$t('last_position')"
          v-model="vessel.last_position"
          @focus="show_position_warning = true"
          @blur="show_position_warning = false"
        />
        <v-alert
          class="mt-1"
            v-show="show_position_warning"
            dense
            text
            type="warning"
          > {{ $t('last_position_warning') }}
          </v-alert>
      </v-col>

      <v-col
        cols=12
        sm=6
      >
        <v-text-field
          :label="$t('distinguishing_features')"
          v-model="vessel.distinguishing_features"
        />
      </v-col>

      <v-col
        cols=6
      >
        <vessel-control ref="vesselMonitoring"></vessel-control>
      </v-col>

      <v-col
        cols=12
        sm=6>
        <h2
          class="mb-3"
        >{{ $t('action_required') }}</h2>
        <v-row>
          <v-col>
            <v-checkbox
              v-if="requestCategory === 'category_1'"
              v-model="vessel.no_action"
              @click="clearActions(vessel)"
              :label="$t('no_action')"
              dense
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols=6>
            <v-checkbox
              :disabled="vessel.no_action !== '' && vessel.no_action"
              v-model="vessel.sighting_report"
              :label="$t('sighting_report')"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols=6>
            <v-checkbox
              :disabled="vessel.no_action !== '' && vessel.no_action"
              v-model="vessel.port_control"
              :label="$t('airport_control')"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols=6>
            <v-checkbox
              :disabled="vessel.no_action !== '' && vessel.no_action"
              :label="$t('crew_list')"
              v-model="vessel.crew_list"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols=6>
            <v-checkbox
              :disabled="vessel.no_action !== '' && vessel.no_action"
              :label="$t('passenger_list')"
              v-model="vessel.passenger_list"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols=6>
            <v-checkbox
              :disabled="vessel.no_action !== '' && vessel.no_action"
              :label="$t('aeroplane_inspection')"
              v-model="vessel.vessel_inspection"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols=6>
            <v-checkbox
              :disabled="vessel.no_action !== '' && vessel.no_action"
              :label="$t('vessel_other_actions')"
              v-model="vessel.other_actions"
              dense
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col
            v-if="vessel.other_actions"
            cols=12
          >
            <v-textarea
              visible
              outlined
              name="input-7-4"
              :label="$t('indicate_other_actions')"
              v-model="vessel.other_actions_info"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'
import VesselControl from './VesselControl'
import YearPicker from '../ui/YearPicker'
import { ExportUtils } from '../../services/DataExport'
import { VesselUtils } from '../../services/VesselUtils'

export default {
  name: 'AeroplaneDetails',
  props: ['requestCategory'],
  components: {
    VesselControl,
    YearPicker
  },
  data: vm => ({
    countries: maocData.dynamicLocalizedSelect('countries'),
    vessel: {
      no_action: '',
      sighting_report: '',
      crew_list: '',
      passenger_list: '',
      vessel_inspection: '',
      port_control: '',
      yearPicker: YearPicker.newPickerObject()
    },
    show_position_warning: false
  }),
  methods: {
    clearActions (vessel) {
      vessel.sighting_report = false
      vessel.port_control = false
      vessel.crew_list = false
      vessel.passenger_list = false
      vessel.vessel_inspection = false
      vessel.other_actions = false
    },
    getData: function () {
      this.vessel.year_of_build = this.vessel.yearPicker.year

      const monitoringData = this.$refs.vesselMonitoring.getData()

      if (Object.keys(monitoringData).length > 0) {
        this.vessel.monitoring = monitoringData
      }

      if (this.vessel.flag) {
        this.vessel.flag_en = this.$t('countries.' + this.vessel.flag, 'en')
      }
      if (VesselUtils.vesselActionRequired(this.vessel)) {
        this.vessel.required_action_en = ExportUtils.formatVesselRequiredActions(this.vessel)
      }
      return ExportUtils.copyObject(this.vessel, ['yearPicker'])
    },
    setData: function (data) {
      this.$refs.vesselMonitoring.setData(data.monitoring)
      delete data.monitoring
      this.vessel = Object.assign(this.vessel, data)
      this.vessel.yearPicker.year = this.vessel.year_of_build
      this.$forceUpdate()
    }
  }
}
</script>
